var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('HomeFilterArea'),_c('HotSearch'),_c('HomeCTA'),_c('HomeQuickHelp'),_c('HomeTestimonials'),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }